import React, { useEffect, useState } from "react";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import NewRegistrationModal from "components/Private/NewRegistrationModal";
import Swal from 'sweetalert2';
import EditGuestModal from "components/Private/EditGuestModal";
import { useGuestContext } from '../../contexts/GuestContext';
// react-bootstrap components
import {
    Modal,
    Button,
    Card,
    Nav,
    Container,
    Dropdown,
    Row,
    Col,
    OverlayTrigger, Tooltip
} from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import SheetUpload from "components/Private/SheetUpload";
import { Scrollbars } from 'react-custom-scrollbars';
// core components
import ReactTable from "../../components/ReactTable/ReactTable";

function SutraTranslator() {

   
    return (
        <>
           To be Developed
        </>
    );
}
export default SutraTranslator;
